function setCookie(key, value) {
    var date = new Date(),
        t = 5;
    date.setDate(date.getDate() + t);
    document.cookie = key + '=' + encodeURIComponent(value) + ';expires=' + date.toGMTString();
}
function getCookie(key) {
    var arr, reg = RegExp('(^| )' + key + '=([^;]+)(;|$)');
    if (arr = document.cookie.match(reg))    //["username=liuwei;", "", "liuwei", ";"]
        return decodeURIComponent(arr[2]);
    else
        return null;
}
function delCookie(key) {
    var date = new Date();
    date.setTime(date.getTime() - 1);
    var delValue = getCookie(key);
    if (!!delValue) {
        document.cookie = key + '=' + delValue + ';expires=' + date.toGMTString();
    }
}

export default {
    name: 'Login',
    data() {
        return {
            activeIndex: 'pwd',
            // 账户密码登录数据
            pwdLoginData: {
                userName: '',
                password: '',
            },
            isLogining: false,
            pwdLoginDataValidate: {
                userName: [
                    { required: true, message: '请输入账户！', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码！', trigger: 'blur' }
                ],
            },
            type: 'text'
        };
    },
    methods: {
        // 用于初始化一些数据
       init() { 
            
        },
        // 用于更新一些数据
        update() { },
        async pwdLogin() {
                  
            this.$refs['pwdLoginForm'].validate((valid) => {
                if (valid) {
                    this.isLogining = true; 
                    this.$http.post('WebUser/AccountLogin', {userName:this.pwdLoginData.userName,passwordhash:this.pwdLoginData.password}).then((res) => {
                    this.isLogining = false;
                    if (res.Status) {
                            // 登录成功 
                            localStorage.UserInfo =  JSON.stringify(res.Result.UserInfo);
                            localStorage.token = res.Result.token;
                            setCookie('jwt', res.Result.Token);   
                            this.$success('登录成功！'); 
                            
                            if (this.pwdStrength) {
                                // 密码强度足够
                                window.location.href = window.location.origin;
                                localStorage.removeItem('noPwd');
                            } else {
                                // 密码强度不够
                                localStorage['noPwd'] = '1';
                                this.$refs['edit-pwd'].show(true, '您的密码过于简单，请设置由数字和字母组成的密码！', () => {
                                    this.$alert('密码已修改，请重新登录', '提示', {
                                        confirmButtonText: '确定',
                                        callback: action => {
                                            localStorage.clear();
                                            sessionStorage.clear();
                                            setTimeout(() => {
                                                window.location.reload()
                                            }, 300);
                                        }
                                    });
                                });
                            }
                      
    
                        } else {
                            // 登录失败
                            this.$error(res.Msg);
                        }
                
                    });;
                  


                     
                } 
            })

        }
    },
    // 计算属性
    computed: {
        // 密码强度
        pwdStrength() {
            const re = /^(?=.*[a-zA-Z])(?=.*\d)[^]{6,16}$/;
            return re.test(this.pwdLoginData.password);
        }
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() {
    },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {

        /*
15963126777
218218
*/

        this.$nextTick(() => { });
    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() {
    },
    // keep-alive 组件激活时调用。
    activated() {
        localStorage.clear();
        sessionStorage.clear();
    },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。此
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {},
    // 组件列表
    components: {
        'login-model-button-item': {
            render(h) {
                let self = this;
                return h(
                    'div', {
                        'class': ['login-model-button-item', { 'active': this.isActive }],
                        on: { click: () => self.$emit('click') },

                    },
                    [
                        h('div', { 'class': 'icon' }, this.$slots['icon']),
                        h('div', { 'class': 'title' }, this.$slots['default']),
                    ]
                );
            },
            props: {
                isActive: {
                    type: Boolean,
                    default: false,
                }
            }
        }
    },
};